/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { BaseCartState } from '../cart-state/base-cart-state';
import { ICartState } from '../state-interfaces/i-cart-state';
import createGlobalStateDataAction from './global-state-data-action';

export default createGlobalStateDataAction<ICartState>('CARTSTATE', BaseCartState);
